import { render, staticRenderFns } from "./ServiceSliderComponent.vue?vue&type=template&id=fceb3504"
import script from "./ServiceSliderComponent.vue?vue&type=script&lang=js"
export * from "./ServiceSliderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports